import { useTranslation } from "react-i18next";

import styles from "./Badge.module.scss";

interface BadgeProps {
  label: string;
  color: string;
}

const Badge = ({ label, color }: BadgeProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={styles.badge}
      style={{ color, backgroundColor: `${color}1a` }}
    >
      {t(label)}
    </span>
  );
};

export default Badge;
